import type { ManualReferralEntitySearchItem } from '../../types/manual-referral.type';

type ManualReferralSummaryProps = {
  title: string;
  entity: ManualReferralEntitySearchItem;
};

export const ManualReferralSummary = ({ title, entity }: ManualReferralSummaryProps) => (
  <div className="rounded-md border border-gray-200 bg-gray-50 p-3 text-sm">
    <p className="text-xs font-semibold uppercase tracking-wide text-gray-500">{title}</p>
    <p className="mt-1 font-medium text-gray-900">{entity.label}</p>
    <p className="text-gray-600">{entity.email}</p>
    {entity.organizationName && <p className="text-gray-600">{entity.organizationName}</p>}
  </div>
);
